// STYLES
import * as Style from "./SideMenuStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

// MISC

// ASSETS
import HomeIconSelected from "assets/Icons/HomeIconSelected.svg";
import HomeIconUnselected from "assets/Icons/HomeIconUnselected.svg";
import LogoutIcon from "assets/Icons/LogoutIcon.svg";
import PostsIconSelected from "assets/Icons/PostsIconSelected.svg";
import PostsIconUnselected from "assets/Icons/PostsIconUnselected.svg";
import RumzIconSelected from "assets/Icons/RumzIconSelected.svg";
import RumzIconUnselected from "assets/Icons/RumzIconUnselected.svg";
import SubscriptionsIconSelected from "assets/Icons/SubscriptionsIconSelected.svg";
import SubscriptionsIconUnselected from "assets/Icons/SubscriptionsIconUnselected.svg";
import SupportIconUnselected from "assets/Icons/SupportIconUnselected.svg";
import SupportIconSelected from "assets/Icons/SupportIconSelected.svg";
import NotificationsIconUnselected from "assets/Icons/NotificationsIconUnselected.svg";
import NotificationsIconSelected from "assets/Icons/NotificationsIconSelected.svg";

// REDUX
import { useAppDispatch } from "hooks/reduxHooks";
import { MenuItem } from "./SideMenuModel";
import { setTokenToInitialState } from "slices/sessionSlice";
import { handleResetFiltersState } from "slices/filtersSlice";
import { Tooltip } from "@material-ui/core";
import CustomTooltip from "components/CustomToolTip/CustomToolTip";
import StyledTooltip from "components/CustomToolTip/CustomToolTip";

// COMPONENTS

const SideMenu = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS
  const currentLocation = location.pathname;

  // Helper function to check if user is "mondo"
  const isMondoUser = () => {
    const username = localStorage.getItem('username');
    return username === 'mondo';
  };

  // Base menu items
  const baseMenuItems: MenuItem[] = [
    { path: "/dashboard", iconSelected: HomeIconSelected, iconUnselected: HomeIconUnselected },
    { path: "/reports", iconSelected: PostsIconSelected, iconUnselected: PostsIconUnselected },
    { path: "/invoices", iconSelected: PostsIconSelected, iconUnselected: PostsIconUnselected },
    { path: "/audit", iconSelected: PostsIconSelected, iconUnselected: PostsIconUnselected },
    { path: "/lockerList", iconSelected: SubscriptionsIconSelected, iconUnselected: SubscriptionsIconUnselected },
    { path: "/support", iconSelected: SupportIconSelected, iconUnselected: SupportIconUnselected },
    { path: "/push-notifications", iconSelected: NotificationsIconSelected, iconUnselected: NotificationsIconUnselected },
    { path: "/discounts", iconSelected: RumzIconSelected, iconUnselected: RumzIconUnselected },
  ];

  // Filter menu items for mondo user
  const menuItems = isMondoUser()
    ? baseMenuItems.filter(item =>
      !item.path.includes('/support') &&
      !item.path.includes('/push-notifications') &&
      !item.path.includes('/discounts')
    )
    : baseMenuItems;

  //USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleNavigate = (path) => {
    dispatch(handleResetFiltersState());
    navigate(path);
  };

  const handleLogout = () => {
    navigate("/");
    dispatch(setTokenToInitialState());
  };

  function CustomTooltipPopper(props) {
    return (
      <div style={{ backgroundColor: 'blue', color: 'white', padding: '10px', height: '100px' }}>
        {props.title}
      </div>
    );
  }

  return (
    <Style.SideMenuContainer>
      {menuItems.map((item) => (
        <StyledTooltip tooltipText={item.path.slice(1)} position="right">
          <Style.SideMenuObject
            key={item.path}
            selected={currentLocation === item.path}
            onClick={() => handleNavigate(item.path)}
            startIcon={
              <Style.ImageWrapper>
                <Style.Image
                  src={currentLocation === item.path ? item.iconSelected : item.iconUnselected}
                  alt=""
                />
              </Style.ImageWrapper>
            }
            size="small"
          />
        </StyledTooltip>

      )

      )}
      <Style.LogoutButton
        colorValue='#1D1D26'
        selected={false}
        onClick={handleLogout}
        startIcon={
          <Style.ImageWrapper>
            <Style.Images src={LogoutIcon} alt="" />
          </Style.ImageWrapper>
        }
        size="small"
      />
    </Style.SideMenuContainer>
  );
};

export default SideMenu;
